module.exports = __webpack_public_path__ + "static/media/edge.4f5d9b7e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/edge.mp3
// module id = 510
// module chunks = 0